import React from 'react'
import PropTypes from 'prop-types'
import {createUseStyles} from 'react-jss'

const useStyles = createUseStyles(theme => ({
	container: {
		zIndex: '5',
		maxWidth: '1460px',
		margin: '0px auto 0px',
		padding: '0px 10px',
		'@media screen and (min-width: 410px)': {
			padding: '0px 30px',
		},
		'@media screen and (min-width: 992px)': {
			margin: '0px auto 0px',
			paddingTop: '50px',
		},
	},
	titleContainer: {
		zIndex: '5',
		position: 'static',
		padding: '6px 10px',
		'@media screen and (min-width: 410px)': {
			padding: '6px 30px',
		},
		'@media screen and (min-width: 992px)': {
			position: 'fixed',
		},
		width: '100%',
		fontSize: '18px',
		backgroundColor: theme.colors.primary,
		borderBottom: '2px solid #ebebeb',
	},
	title: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between',
		alignItems: 'center',
		maxWidth: '1400px',
		margin: '0 auto',
		color: '#fff',
		fontSize: '18px',
		lineHeight: '36px',
		'& a': {
			color: '#fff',
			textDecoration: 'none'
		}
	}
}));

const StickyTitle = ({children, title, titleWrapper, className, ...restProps}) => {
	const classes = useStyles();
	return (
		<>
			<div className={classes.titleContainer}>
				{React.createElement(titleWrapper, {className: classes.title}, title)}
			</div>
			<div {...restProps} className={className || classes.container}>{children}</div>
		</>
	);
};


StickyTitle.propTypes = {
	title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
	titleWrapper: PropTypes.string
};

StickyTitle.defaultProps = {
	titleWrapper: 'h1'
};

export default StickyTitle;
